import React from 'react';
import { Grid, Typography } from '@mui/material';
import ContactUsForm from '../components/ContactUsForm';


const Appointment = () => {
    return (
        <Grid container spacing={2}
        sx={{
            marginTop:'20vh',
            padding: '2vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}
        >
            <Grid item xs={12} >
           
          <Typography
            variant="h4"
            sx={{
                fontWeight: "bold",
                marginBottom: 3,
                color: '#fd0b0b',
    
                fontFamily: "Cursive",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
                textAlign: "center",
            }}
          >
                Termin vereinbaren

          </Typography>
    

                 

            </Grid>
            <Grid item xs={12} md={6} >
                <ContactUsForm/>
                </Grid>
            
            
        </Grid>
    );
};

export default Appointment;